<template>
  <div>
    <!-- Contact month, CH Offer -->
    <div class="row">
      <!-- Contact month -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <Input
            :label="$t('campaignDesigner.contentSelection.contactMonth.label')"
            :validation="['required']"
            :tooltip="$t('campaignDesigner.contentSelection.contactMonth.tooltip')"
            tooltip-direction="right"
            ref="setting_contentMonth"
            v-if="editable"
            v-model="contactMonth" />

          <OutputField
            :label="$t('campaignDesigner.contentSelection.contactMonth.label')"
            :tooltip="$t('campaignDesigner.contentSelection.contactMonth.tooltip')"
            :value="contactMonth"
            tooltip-direction="right"
            v-else />
        </div>
      </div>

      <!-- Ch Offer -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <Input
            :label="$t('campaignDesigner.contentSelection.chOffer')"
            v-if="editable"
            v-model="chOffer" />

          <OutputField
            :label="$t('campaignDesigner.contentSelection.chOffer')"
            :value="chOffer"
            v-else />
        </div>
      </div>
    </div>

    <!-- Ch Level 1, Ch Level 2 -->
    <div class="row">
      <!-- Ch Level 1 -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <Input
            :label="$t('campaignDesigner.contentSelection.chLevel1')"
            v-if="editable"
            v-model="chLevel1" />

          <OutputField
            :label="$t('campaignDesigner.contentSelection.chLevel1')"
            :value="chLevel1"
            v-else />
        </div>
      </div>

      <!-- Ch Level 2 -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <Input
            :label="$t('campaignDesigner.contentSelection.chLevel2')"
            v-if="editable"
            v-model="chLevel2" />

          <OutputField
            :label="$t('campaignDesigner.contentSelection.chLevel2')"
            :value="chLevel2"
            v-else />
        </div>
      </div>
    </div>

    <!-- Ch Level 3, Ch Level 4 -->
    <div class="row">
      <!-- Ch Level 3 -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <Input
            :label="$t('campaignDesigner.contentSelection.chLevel3')"
            v-if="editable"
            v-model="chLevel3" />

          <OutputField
            :label="$t('campaignDesigner.contentSelection.chLevel3')"
            :value="chLevel3"
            v-else />
        </div>
      </div>

      <!-- Ch Level 4 -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <Input
            :label="$t('campaignDesigner.contentSelection.chLevel4')"
            v-if="editable"
            v-model="chLevel4" />

          <OutputField
            :label="$t('campaignDesigner.contentSelection.chLevel4')"
            :value="chLevel4"
            v-else />
        </div>
      </div>
    </div>

    <!-- Template -->
    <div class="row">
      <!-- Template -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <TextArea
            :label="$t('campaignDesigner.contentSelection.template')"
            max-length="4000"
            ref="setting_template"
            required
            v-if="editable"
            v-model="template" />

          <OutputField
            :label="$t('campaignDesigner.contentSelection.template')"
            :value="template"
            v-else />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Input from '../../../../slds/Input'
import OutputField from '../../../../slds/OutputField'
import TextArea from '../../../../slds/TextArea'
import _ from 'lodash'
export default {
  components: {
    Input,
    OutputField,
    TextArea
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
      required: true
    },
    value: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  methods: {
    resetValidation () {
      Object.values(this.$refs).forEach(ref => {
        if (ref.clearValidationError) {
          ref.clearValidationError()
        }
      })
    },
    getSectionToSave () {
      return {
        contactMonth: {
          selected: this.contactMonth
        },
        chOffer: {
          selected: this.chOffer
        },
        chLevel1: {
          selected: this.chLevel1
        },
        chLevel2: {
          selected: this.chLevel2
        },
        chLevel3: {
          selected: this.chLevel3
        },
        chLevel4: {
          selected: this.chLevel4
        },
        template: {
          selected: this.template
        }
      }
    },
    mapValue (value) {
      const {
        contactMonth,
        chOffer,
        chLevel1,
        chLevel2,
        chLevel3,
        chLevel4,
        template
      } = value

      this.contactMonth = contactMonth.selected
      this.chOffer = chOffer.selected
      this.chLevel1 = chLevel1.selected
      this.chLevel2 = chLevel2.selected
      this.chLevel3 = chLevel3.selected
      this.chLevel4 = chLevel4.selected
      this.template = template.selected
    },
    validate () {
      return Object.values(this.$refs)
        .flat()
        .map(r => r.validate())
        .every(v => !!v)
    }
  },
  data () {
    return {
      contactMonth: '',
      chOffer: '',
      chLevel1: '',
      chLevel2: '',
      chLevel3: '',
      chLevel4: '',
      template: ''
    }
  },
  mounted () {
    this.resetValidation()
    this.mapValue(this.value)
  },
  watch: {
    value (newValue) {
      this.resetValidation()
      this.mapValue(newValue)
    }
  },
}
</script>
<style lang="scss" scoped>
  .full-height {
    height: 100%;
    overflow-y: auto;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .col {
    flex-grow: 1;
  }
</style>
